/*=========================================================================================
  File Name: moduleCalendarState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  icons: [],
  modules: [],
  roles: [],
  currentMenuToEdit: {},
  currentMenuToDelete: {},
  unsavedLayout: false,
  currentItemToDelete: '',
  role: {}
}
